import Cargos from '@/models/Cargos'

export default [
  {
    path: '/administrativo/pagarbarbeiro',
    name: 'rota-pagarbarbeiro',
    autenticado: true,
    cargo: [Cargos.ADMINISTRADOR],
    titulo: 'Pagar barbeiro',
    layout: 'LayoutBarraLateral',
    menu: {
      label: 'Pagar barbeiro',
      icon: 'hand-holding-usd',
    },
    component: () => import(/* webpackChunkName: "servicos" */ '../views/pagarbarbeiro/PagarBarbeiro.vue'),
  },
]
